<template>
  <div class="content">
    <b-container class="m-0 p-0" fluid>
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1 pt-2"
          footer-classes="pb-2"
        >
          <div>
            <b-col
              cols="12"
              style="
                position: fixed;
                padding: 0px 15px;
                width: 100%;
                left: 0;
                background: #fff;
                z-index: 999999;
                top: 0px;
              "
              class="justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input
                v-model="searchQuery"
                class="w-100"
                prepend-icon="fas fa-search"
                placeholder="Nome ou apelido"
              >
              </base-input>
            </b-col>

            <el-table
              v-loading="tableLoading"
              v-if="!tableLoading"
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light d-none"
              row-class-name="thead-lightsx"
              cel-class-name="thead-cel"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              class="w-100 mt-5"
            >
              <el-table-column
                width="100"
                align="right"
                :class="'p-0'"
                label="Ações"
              >
                <div slot-scope="{ $index, row }" class="d-flex p-0">
                  <base-button
                    @click="handleClick($index, row)"
                    class="details"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-check pt-0 pb-0 pl-2 pr-2"></i>
                  </base-button>
                </div>
              </el-table-column>

              <el-table-column width="auto" align="left" label="Nome">
                <div slot-scope="{ idx, row }" class="d-flex">
                  {{ row['name'] }}
                  {{ row['nickname'] ? ' - ' + row['nickname'] : '' }}
                </div>
              </el-table-column>
              <!-- <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column"> -->
              <!-- <div slot-scope="{ $index, row }" class="d-flex"> -->

              <!-- <span v-if="column.prop == 'uuid'"> -->
              <!-- <b-img v-if="row.images != '' && row.images != null" width="45px" -->
              <!-- onerror="if(this.alt == ''){this.src='process.env.IMG_AVATAR_DEFAULT'; this.alt = 'sem imagem';}" -->
              <!-- :src="getCakeBaseURL() + 'images/display/' + row.images"> -->
              <!-- </b-img> -->
              <!-- <b-img v-else width="45px" src="process.env.IMG_AVATAR_DEFAULT" /> -->
              <!-- <qrcode-vue v-else :renderAs="'svg'" :image="row.images" :size="45"
                                            :value="getWindowOrigin + '/condutor/' + row[column.prop] + '/'">
                                        </qrcode-vue> -->
              <!-- </span> -->
              <!-- <span v-else> -->
              <!-- {{ row[column.prop] }} -->
              <!-- <span v-if="row[column.prop].length > 1">
                        ***{{row[column.prop].substring(3,12)}}**
                      </span> -->
              <!-- </span> -->
              <!-- </div> -->
              <!-- </el-table-column> -->
            </el-table>
          </div>

          <div
            v-if="true"
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando <b>{{ from + 1 }}</b> a {{ to }} de <b>{{ total }}</b>

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} item(s) selecionado(s)
                </span>
              </p>
            </div>

            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Card from '@/components/Cards/Card.vue'
import { Table, TableColumn, Select, Option, Col } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from './../Tables/PaginatedTables/clientPaginationMixin'
import janooService from './../../services/janoo/index'
import swal from 'sweetalert2'
// import qrcodeVue from "qrcode.vue"

export const cakeBaseURL = process.env.VUE_APP_API_CAKE_URL // cake api

export default {
  mixins: [clientPaginationMixin],

  components: {
    Card,
    BasePagination,
    // qrcodeVue,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  data() {
    return {
      selectedRows: [],
      formattedBillItems: [],
      tableColumns: [
        // {
        //     prop: "uuid",
        //     label: "QRCode",
        //     //minWidth: 100,
        //     width: 90,
        //     padding: 0,
        //     sortable: false
        // },
        {
          prop: 'name',
          label: 'Nome',
          minWidth: 'auto',
          sortable: true,
        },
        // {
        //     prop: "nickname",
        //     label: "Apelido",
        //     minWidth: 100,
        //     sortable: true
        // },
        //   {
        //     prop: "cpf",
        //     label: "CPF",
        //     minWidth: 100,
        //     sortable: true
        //   }
      ],
      tableLoading: false,
    }
  },

  computed: {
    ...mapState('agent', ['agents']),
  },

  methods: {
    ...mapActions('agent', ['getAllAgents', 'setAgentData', 'getAgentByUUID']),

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    handleClick(index, agent) {
      // //todo varrer e ajustar checkbox e multiselects bind to array
      // if(agent['Ativo'] == 1){
      //   agent['Ativo'] = true
      // }
      // this.agent = JSON.parse(JSON.stringify(agent))
      // this.openAgentModal = true
      // this.currentAgentData = {}
      // this.currentAgentData.rowIndex = index
      // delete this.agent.place_id
      let userID = 0
      let bookingHash = 0
      //get booking ID from URL
      Object.entries(this.$route.query).map((param, idx) => {
        if (undefined != param[1] && bookingHash == 0) {
          bookingHash = param[1].split('/')
          if (
            !isNaN(bookingHash[0]) &&
            undefined != bookingHash[1] &&
            !isNaN(bookingHash[1])
          ) {
            userID = bookingHash[1]
            bookingHash = bookingHash[0]
          }
        }
      })

      //mount agent data
      if (null != agent.cpf) {
        agent.cpf = `***${agent.cpf.substring(3, 12)}**`
      }
      let agentData = {
        name: agent.name,
        place: agent.Place.name,
        nickname: agent.nickname,
        CPF: agent.cpf,
        UUID: agent.uuid,
        image: `${process.env.VUE_APP_API_CAKE_URL}images/display/${agent.images}`,
      }
      agentData = btoa(JSON.stringify(agentData)) //.replace(/=/g, '')
      //send data to janoo
      janooService
        .setBillItemAgent(agentData, bookingHash, userID)
        .then((response) => {
          swal
            .fire({
              text: 'Condutor Selecionado!',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success',
              icon: 'success',
            })
            .then((value) => {
              //parent signal to close
              window.parent.postMessage(
                JSON.stringify({ reload: true, agent: agentData }),
                '*'
              )
              swal.close()
            })
        })
        .catch((error) => {
          if (bookingHash == 0) {
            swal
              .fire({
                text: 'Erro ao vincular condutor',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-warning',
                icon: 'warning',
              })
              .then((value) => {
                swal.close()
              })
          }
        })
    },

    async populateTable() {
      try {
        this.tableLoading = true
        this.formattedBillItems = [...this.agents]
      } catch (error) {
      } finally {
        this.tableLoading = false
      }
    },

    getWindowOrigin() {
      return window.location.origin
    },
  },

  async mounted() {
    this.pagination.perPage = 20
    await this.getAllAgents(this.$route.query.bc_key)
    await this.populateTable()
    await this.createFuseSearch(['name', 'mobile', 'nickname'])
  },

  created() {
    this.$on('reset-pagination', function (e) {
      this.paginationChanged(1)
    })
  },
}
</script>
